module.exports = __webpack_public_path__ + "images/183_2048.jpg";